"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeFormListItem = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const formik_1 = require("formik");
const attribute_form_list_item_styles_1 = require("./attribute-form-list-item.styles");
const create_attribute_form_constants_1 = require("../create-attribute-form.constants");
const localization_1 = require("../../../../../localization");
exports.AttributeFormListItem = (0, react_1.forwardRef)(({ itemLabel, name: fieldName, children, descriptionFieldTitle, isRemoveDisabled, hideDescription, isReadOnly, isNestedListHeightDynamic, readonly, isDuplicate, onRemoveClick, }, ref) => {
    const [, { value: description = '', error: descriptionError, touched: descriptionTouched, initialValue: initialDescription, }, { setValue: setDescription, setTouched: setDescriptionTouched },] = (0, formik_1.useField)(`${fieldName}.${create_attribute_form_constants_1.AttributeFormFieldNames.Description}`);
    const [, , { setValue: setIsDescriptionChanged }] = (0, formik_1.useField)(`${fieldName}.${create_attribute_form_constants_1.AttributeFormFieldNames.IsDescriptionChanged}`);
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [textValue, setTextValue] = (0, react_1.useState)(description);
    (0, react_1.useEffect)(() => {
        setTextValue(description);
    }, [description]);
    const setIsDescriptionChangedValue = (0, react_1.useCallback)((value) => {
        if (!hideDescription) {
            void setIsDescriptionChanged(initialDescription !== value);
        }
    }, [hideDescription, initialDescription, setIsDescriptionChanged]);
    const handleDescriptionValueChange = (0, react_1.useCallback)((e) => {
        const nextValue = e.target.value;
        setTextValue(nextValue);
        void setDescription(nextValue);
        setIsDescriptionChangedValue(nextValue);
    }, [setDescription, setIsDescriptionChangedValue]);
    const handleDescriptionChange = (0, react_1.useCallback)(() => {
        void setDescription(textValue);
        void setDescriptionTouched(true);
        if (textValue !== description) {
            setIsDescriptionChangedValue(textValue);
        }
    }, [setDescription, setDescriptionTouched, textValue, description, setIsDescriptionChangedValue]);
    const handleClearDescription = (0, react_1.useCallback)((e) => {
        e.preventDefault();
        setTextValue('');
        void setDescription('');
        void setDescriptionTouched(true);
        setIsDescriptionChangedValue('');
    }, [setDescription, setDescriptionTouched, setIsDescriptionChangedValue]);
    const showDescriptionError = descriptionTouched && !!descriptionError;
    const inputProps = (0, react_1.useMemo)(() => {
        if (isReadOnly || !textValue)
            return undefined;
        return {
            endAdornment: (react_1.default.createElement(material_1.InputAdornment, { position: "end" }, react_1.default.createElement(material_1.IconButton, { size: "small", onMouseDown: (e) => e.preventDefault(), onClick: handleClearDescription }, react_1.default.createElement(ui_components_1.Icon, { variant: "cancel", color: ui_components_1.baseColors.gray300, width: 20, height: 20 })))),
        };
    }, [isReadOnly, textValue, handleClearDescription]);
    return (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(attribute_form_list_item_styles_1.StyledFormListItem, { ref: ref }, react_1.default.createElement("div", { className: "attribute-list-item-name-container" }, react_1.default.createElement("div", { className: "attribute-list-item-name", title: itemLabel }, itemLabel || '\u00A0')), !hideDescription && (react_1.default.createElement("div", { className: "attribute-list-item-description" }, react_1.default.createElement(ui_components_1.TextField, { fullWidth: true, multiline: true, maxRows: 4, label: descriptionFieldTitle, className: "attribute-list-item-textarea", variant: "outlined", size: "small", InputProps: inputProps, error: showDescriptionError, helperText: showDescriptionError && descriptionError, value: textValue, onChange: handleDescriptionValueChange, onBlur: handleDescriptionChange, disabled: isReadOnly }), isDuplicate && !hideDescription && (react_1.default.createElement(ui_components_1.Typography, { color: "error", variant: "caption", className: "attribute-list-item-duplicate-error" }, t({ key: 'VALIDATION_MUST_BE_UNIQUE', values: { name: t({ key: 'VALUE' }) } }))))), !readonly && !isRemoveDisabled && (react_1.default.createElement(material_1.IconButton, { type: "button", onClick: onRemoveClick, className: "attribute-list-item-action-delete" }, react_1.default.createElement(ui_components_1.Icon, { variant: "minus", color: ui_components_1.baseColors.gray300, width: 20, height: 20 })))), children && (react_1.default.createElement(attribute_form_list_item_styles_1.StyledNestedList, { className: isNestedListHeightDynamic ? 'attribute-list-item-nested-list--dynamic' : undefined }, children))));
});
exports.AttributeFormListItem.displayName = 'AttributeFormListItem';
exports.default = exports.AttributeFormListItem;
